import { ButtonBase } from '@mui/material'
import FlagIcon from '@mui/icons-material/Flag'
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined'
import { colorTokens } from '../../../../shared/styles/theme'
import { RADIUS } from '../../../../shared/styles/radii'

interface Props {
  isReported: boolean
  onToggle: () => void
  /** 読み上げ用の項目名。「保険者番号を報告」のように読める形にする。 */
  fieldLabel: string
}

/**
 * 報告のトグル。**常時表示**(hover に隠さない)。
 *
 * 03-patterns/hover-only-chrome.md は hover に置いてよいのを補助操作に限り、コピーだけを
 * 「業務の主動線。隠すと主作業が遅くなる」として常時表示の例外にしている。杏林堂にとっての
 * 報告はコピーと同じ位置にある(本番10日で472回・顧客が唯一はっきり褒めた機能)。
 *
 * - 当たりは 24px 角(規約の最低 22px 角)・自前の hover 背景で別ターゲットだと示す
 * - `is_reported` の反転。取り消せるので確認 dialog は置かない(modals.md §3 の可逆側)
 * - **色で重要度を出さない**。報告済みは塗り / 未報告は輪郭の二値で示す
 *   (00-principles/04-color-discipline.md §4。一覧の行頭ドットと同じ語彙)
 */
export const ReportToggle = ({ isReported, onToggle, fieldLabel }: Props) => (
  <ButtonBase
    onClick={onToggle}
    aria-label={
      isReported ? `${fieldLabel}の報告を取り消す` : `${fieldLabel}を報告`
    }
    aria-pressed={isReported}
    sx={{
      width: 24,
      height: 24,
      flexShrink: 0,
      borderRadius: `${RADIUS.sm}px`,
      color: isReported ? colorTokens.fg.default : colorTokens.fg.disabled,
      '&:hover': { background: colorTokens.overlay.hover },
    }}
  >
    {isReported ? (
      <FlagIcon sx={{ fontSize: 15 }} />
    ) : (
      <FlagOutlinedIcon sx={{ fontSize: 15 }} />
    )}
  </ButtonBase>
)
